import { FormattedMessage } from 'react-intl';
import FileGridPageLayout, {type File} from 'layouts/FileGridPageLayout';

const GUIDES_PATH_PREFIX = '/pdf/help/guides';

const guides: File[] = [
  {
    fileName: `Guide de démarrage tablette.pdf`,
    filePath: GUIDES_PATH_PREFIX,
    label: (
      <FormattedMessage id="category.help.documents.getting_started.tablet_guide" />
    ),
  },
  {
    fileName: `Guide de démarrage station.pdf`,
    filePath: GUIDES_PATH_PREFIX,
    label: (
      <FormattedMessage id="category.help.documents.getting_started.dock_guide" />
    ),
  },
];

const GettingStarted = (): JSX.Element => (
  <FileGridPageLayout
    files={guides}
    title={<FormattedMessage id="category.help.documents.getting_started" />}
  />
);

export default GettingStarted;
